import React from 'react';
import DocumentationSidebar from '../DocumentationSidebar';
import dataDownloadNavConf from './DataDownloadNavConf';

export default function DataDownloadSidebar({ innerRef, loadedMarkdowns }) {
	return (
		<DocumentationSidebar navConf={dataDownloadNavConf} innerRef={innerRef} loadedMarkdowns={loadedMarkdowns} />
	);
}